<template>
  <div>
    <nav class="navbar navbar-light mb-4">
      <div class="container">
        <a class="navbar-brand d-flex align-items-center" href="/">
          <img src="../../assets/logo-e-sea-black.png" height="70" alt="Logo" />
        </a>
      </div>
    </nav>
    <div class="container py-5">
      <div v-if="isLoading" class="text-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div v-else-if="isValid" class="row justify-content-center">
        <div class="col-md-8 col-lg-7">
          <div class="card p-4">
            <div class="card-body">
              <div class="text-center mb-4">
                <h3 class="verified-title mb-3">
                  <i class="fa fa-check-square text-success icon-check mr-2"></i>
                  Dokumen Terverifikasi
                </h3>
                <p class="text-muted">Dokumen ini diterbitkan secara resmi oleh Direktorat Pengendalian Ruang Laut.</p>
              </div>

              <div class="table-responsive">
                <table class="table mb-4">
                  <tbody>
                    <tr v-if="dataVerif.nomor_dokumen">
                      <td class="label-text" width="40%">Nomor Dokumen</td>
                      <td class="value-text">{{ dataVerif.nomor_dokumen }}</td>
                    </tr>
                    <tr v-if="dataVerif.subjek_hukum">
                      <td class="label-text">Subjek Hukum</td>
                      <td class="value-text">{{ dataVerif.subjek_hukum }}</td>
                    </tr>
                    <tr v-if="dataVerif.tipe_dokumen">
                      <td class="label-text">Kategori</td>
                      <td class="value-text">{{ dataVerif.tipe_dokumen }}</td>
                    </tr>
                    <tr v-if="dataVerif.nilai">
                      <td class="label-text">Nilai</td>
                      <td class="value-text">{{ dataVerif.nilai }}</td>
                    </tr>
                    <tr v-if="dataVerif.tahun_laporan">
                      <td class="label-text">Tahun Laporan</td>
                      <td class="value-text">{{ dataVerif.tahun_laporan }}</td>
                    </tr>
                    <tr v-if="dataVerif.penandatangan">
                      <td class="label-text">Ditandatangani oleh</td>
                      <td class="value-text">{{ dataVerif.penandatangan }}</td>
                    </tr>
                    <tr v-if="dataVerif.status">
                      <td class="label-text">Status</td>
                      <td class="status-verified">{{ dataVerif.status }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="text-center mt-2">
                <button
                  class="btn btn-primary font-weight-bold download-btn"
                  @click="unduhDokumen(dataVerif.id_dokumen)"
                >
                  Unduh Dokumen (PDF)
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="row justify-content-center">
        <div class="col-md-8 col-lg-7">
          <div class="card p-4">
            <div class="card-body">
              <div class="text-center">
                <h3 class="invalid-title mb-3">
                  <i class="fa fa-times-circle text-danger icon-large mr-2"></i>
                  Dokumen Tidak Valid
                </h3>
                <div class="alert alert-danger" role="alert">
                  <small>Dokumen ini tidak ditemukan dalam database kami atau telah dicabut.</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { openFileById } from '../../helper/helpernew'
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      isLoading: true,
      isValid: false,
      dataVerif: {
        tipe_dokumen: null,
        nomor_dokumen: null,
        subjek_hukum: null,
        nilai: null,
        tahun_laporan: null,
        penandatangan: null,
        status: null,
        id_dokumen: null,
      },
    }
  },
  methods: {
    openFileById,

    async verifTTE() {
      const tipe = this.$route.query.tipe
      const id_laporan = this.$route.query.id_laporan
      const penandatangan = this.$route.query.penandatangan || ''

      if (!tipe || !id_laporan) {
        this.isLoading = false
        return
      }

      try {
        const res = await axios.get(
          `${this.baseapiPengendalian}api/ref/verifTTE?tipe=${tipe}&id_laporan=${id_laporan}&penandatangan=${penandatangan}`,
        )
        const resData = res.data.data
        this.dataVerif = {
          tipe_dokumen: resData.tipe_dokumen,
          nomor_dokumen: resData.nomor_dokumen,
          subjek_hukum: resData.subjek_hukum,
          nilai: resData.nilai,
          tahun_laporan: resData.tahun_laporan,
          penandatangan: resData.penandatangan,
          status: resData.status,
          id_dokumen: resData.id_dokumen,
        }
        this.isValid = true
      } catch (error) {
        this.isValid = false
      } finally {
        this.isLoading = false
      }
    },

    unduhDokumen(id_dokumen) {
      if (!id_dokumen) {
        Swal.fire('Dokumen tidak tersedia', '', 'error')
        return
      }

      this.openFileById(id_dokumen)
    },
  },
  mounted() {
    this.verifTTE()
  },
}
</script>

<style scoped>
body {
  background-color: #f8f9fa;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.navbar {
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.navbar-brand {
  font-weight: 600;
  color: #333;
}

.card {
  border: none;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.verified-title {
  color: #0056b3;
  font-weight: 700;
}

.table td {
  padding-top: 12px;
  padding-bottom: 12px;
  vertical-align: middle;
  border-top: 1px solid #dee2e6;
}

.table tr:first-child td {
  border-top: none;
}

.label-text {
  color: #333;
  font-weight: 400;
}

.value-text {
  color: #212529;
  font-weight: 500;
}

.status-verified {
  color: #28a745;
  font-weight: bold;
}

.download-btn {
  background: #0033cc;
}

.icon-check {
  font-size: 1.2em;
}

.invalid-title {
  color: #dc3545;
  font-weight: 700;
}

.status-invalid {
  color: #dc3545;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
